import type { Component } from "react"

import type { ReactPerformance } from "@/lib/react_performance"

export const curryUpdateManagedState = <Props, State>(
  component: Component<Props, State>
): ReactPerformance.Functions.UpdateState<State> => {
  return (changes, callback): Promise<State> => {
    return new Promise((resolve, reject) => {
      try {
        component.setState((prevState) => {
          const state = {
            ...(typeof changes === `function` ? changes(prevState) : changes),
            update: true,
          } as State

          resolve(state)

          return state
        }, callback)
      } catch (error) {
        reject(error)
      }
    })
  }
}
